export const CREATE_TASK__REQUEST = 'TASK_TYPE__CREATE_TASK__REQUEST'
export const CREATE_TASK__SUCCESS = 'TASK_TYPE__CREATE_TASK__SUCCESS'
export const CREATE_TASK__FAILURE = 'TASK_TYPE__CREATE_TASK__FAILURE'
export const UPDATE_TASK__REQUEST = 'TASK_TYPE__UPDATE_TASK__REQUEST'
export const UPDATE_TASK__SUCCESS = 'TASK_TYPE__UPDATE_TASK__SUCCESS'
export const UPDATE_TASK__FAILURE = 'TASK_TYPE__UPDATE_TASK__FAILURE'
export const GET_TASK__REQUEST = 'TASK_TYPE__GET_TASK__REQUEST'
export const GET_TASK__SUCCESS = 'TASK_TYPE__GET_TASK__SUCCESS'
export const GET_TASK__FAILURE = 'TASK_TYPE__GET_TASK__FAILURE'
export const CLEAR_TASK = 'TASK_TYPE__CLEAR_TASK'